import { apiErrorMessage, type Freshness } from '@bemor/web-kit';
import { FreshnessState, LoadingCard } from '@bemor/web-kit/ui';
import type { ReactNode } from 'react';

/** The detail-page body: loading card, updating state, error, then the children with the data. */
export function DetailBody<T>({
    query,
    title,
    children,
}: {
    query: {
        data?: { data: T };
        isPending: boolean;
        isError: boolean;
        error: unknown;
        refetch: () => unknown;
        freshness: Freshness;
    };
    title: string;
    children: (data: T) => ReactNode;
}) {
    if (query.freshness.updating)
        return (
            <FreshnessState
                retryAfter={query.freshness.retryAfter}
                onRetry={() => void query.refetch()}
            />
        );
    if (query.isPending) return <LoadingCard title={title} rows={6} />;
    if (query.isError || !query.data)
        return (
            <div
                role="alert"
                className="text-destructive rounded-md border p-4 text-sm"
                data-testid="detail-error"
            >
                {apiErrorMessage(query.error)}
            </div>
        );
    return <>{children(query.data.data)}</>;
}
